module.exports = __webpack_public_path__ + "MaterialIcons-Regular.eot";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.eot
// module id = 84
// module chunks = 0